import { render, staticRenderFns } from "./LandingWeddingES.vue?vue&type=template&id=8b75e434&scoped=true"
import script from "./LandingWeddingES.vue?vue&type=script&lang=js"
export * from "./LandingWeddingES.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b75e434",
  null
  
)

export default component.exports